import React, { useEffect, useState } from 'react'
import InputController from '../../Global/InputController'

const RaitingForm = ({
  control,
  prefix = 'prefix',
  prefixQuestion,
  questionId,
  setValue,
  show,
  editRadio,
}) => {
  const [valueLength, setValueLength] = useState(3)
  const [radioLength, setRadioLength] = useState([])

  useEffect(() => {
    // setValue(`${prefixQuestion}.value`, valueLength)
    let array = Array.from({ length: valueLength }, (_, idx) => {
      return {
        label: idx + 1,
        value: idx + 1,
      }
    })

    // setValue(`${prefix}[${0}].option_text`, array[0].value)
    // setValue(
    //   `${prefix}[${array[array.length - 1].value}].option_text`,
    //   array[array.length - 1].value
    // )

    setRadioLength(array)
  }, [valueLength])

  useEffect(() => {
    if (editRadio) {
      setValueLength(editRadio)
    }
  }, [editRadio])

  return (
    <>
      <div className="col-12">
        <div className="col-lg-4">
          <InputController
            inputType="choosen"
            name={`${prefixQuestion}.value`}
            control={control}
            options={Array.from({ length: 8 }).map((_, idx) => ({
              value: idx + 3,
              label: idx + 3,
            }))}
            changeAction={(e) => setValueLength(e.label)}
          />
        </div>
        <hr />
      </div>
      <div className="container col-12">
        <div className="row align-items-center">
          <div className="col text-center">
            <div className="d-flex justify-content-between">
              {radioLength.map((_, index) => (
                <>
                  <div key={index} className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id={`flexRadioDefault${index}`}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`flexRadioDefault${index}`}
                    >
                      {index + 1}
                    </label>
                    {/* <div className="row"> */}{' '}
                    {index === 0 && (
                      <div className="col-lg-12" style={{ left: '0' }}>
                        <InputController
                          name={`${prefixQuestion}.min`}
                          placeholderTxt="Min"
                          inputType="text"
                          control={control}
                        />
                        {/* <InputController
                          name={`${prefix}[${0}].option_text`}
                          placeholderTxt="Min"
                          inputType="text"
                          control={control}
                        /> */}
                      </div>
                    )}
                    {index === radioLength.length - 1 && (
                      <div className="col-lg-12" style={{ right: '0' }}>
                        <InputController
                          name={`${prefixQuestion}.max`}
                          inputType="text"
                          placeholderTxt="Max"
                          control={control}
                        />
                        {/* <InputController
                          name={`${prefix}[${
                            radioLength[radioLength - 1]
                          }].option_text`}
                          placeholderTxt="Max"
                          inputType="text"
                          control={control}
                        /> */}
                      </div>
                    )}
                  </div>
                  {/* </div> */}
                </>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default RaitingForm
